import createAxiosInstance from './createAxiosInstance'

const instance = createAxiosInstance(process.env.VUE_APP_CORE_URL)

// Swagger: https://local2.kingnetsmart.com.tw/core/index.html#/EvCharging
export const apiEvCharging = {
  DashBoard: {
    getConnectorsSummary: (config) => instance.get('/api/EvCharging/Connectors/Summary', config), // 圓餅圖-充電樁狀態、維護控管
    getPowerUsage: (requestData, config) => instance.get('/api/EvCharging/Chart/PowerUsage', Object.assign({}, { params: requestData }, config)) // 長條圖-社區每日用電量
  },
  Management: {
    getFeatures: (config) => instance.get('/api/EvCharging/FeaturesV2', config), // 取得取得社區Tab顯示
    getConnectors: (requestData, config) => instance.get('/api/EvCharging/Connectors', Object.assign({}, { params: requestData }, config)), // 取得充電樁列表
    patchConnectors: (requestData, config) => instance.patch('/api/EvCharging/Connectors', requestData, config), // 取得充電樁列表
    getFilterOptions: (config) => instance.get('/api/EvCharging/Connectors/FilterOptions', config), // 取得動態篩選資料：充電槍類型、樓層資料
    PostForceStop: (ConnectorSn, config) => instance.post(`/api/EvCharging/Connectors/${ConnectorSn}/ForceStop`, config), // 強制停止充電
    getConnectorAllowList: (connectorSn, config) => instance.get(`/api/EvCharging/Connectors/${connectorSn}/allowlist`, config), // 取得現有充電樁白名單
    putConnectorsAllowList: (connectorSn, requestData) => instance.put(`/api/EvCharging/Connectors/${connectorSn}/allowlist`, requestData) // 更新充電樁白名單
  },
  Record: {
    getRecordList: (requestData, config) => instance.get('/api/EvCharging/Orders', Object.assign({}, { params: requestData }, config)), // 取得紀錄列表
    getRecordDetail: (requestData, config) => instance.get(`/api/EvCharging/Orders/${requestData}`, config), // 取得紀錄詳情
    getExportRecord: (requestData, config) => instance.get('/api/EvCharging/Orders/Export', Object.assign({}, { params: requestData }, config)), // 匯出充電紀錄excel
    getDunningsRecord: (requestData, config) => instance.get('/api/EvCharging/Dunnings', Object.assign({}, { params: requestData }, config)), // 取得催繳紀錄
    postDunnings: (requestData, config) => instance.post('/api/EvCharging/Dunnings', requestData, config) // 催繳
  },
  RateSetting: {
    getRateSetting: (config) => instance.get('/api/EvCharging/Settings', config), // 取得費率設定
    patchRateSetting: (requestData, config) => instance.patch('/api/EvCharging/Settings', requestData, config) // 修改費率設定
  },
  ChargingFeeList: {
    getChargingFeeList: (params) => instance.get('/api/EvCharging/Statements', { params }), // 取得帳單列表
    getChargingFeeListExcel: (period, config) => instance.get(`/api/EvCharging/Statements/${period}/Download`, config) // 下載帳單列表
  },
  ManagementFeeList: {
    getManagementFeeStatements: (params) => instance.get('/api/EvCharging/ManagementFeeStatements', { params }), // 取得產單報表列表
    getManagementFeeStatementsDetailsExcel: (period, config) => instance.get(`/api/EvCharging/ManagementFeeStatements/${period}/Details/Download`, config), // 取得產單請款明細檔案
    getManagementFeeStatementsImportTemplateExcel: (period, config) => instance.get(`/api/EvCharging/ManagementFeeStatements/${period}/ImportSample/Download`, config) // 取得管理費匯入範本
  },
  Community: {
    GetTags: (config) => instance.get('/api/Community/Tag', Object.assign({}, config)), // 取得棟
    GetFloors: (tag, config) => instance.get(`/api/Community/Tag/${tag}/Floor`, config), // 取得樓
    GetTablets: (tag, floor, config) => instance.get(`/api/Community/Tag/${tag}/Floor/${floor}/Tablet`, config) // 取得戶
  },
  PowerDistribution: {
    getDistributorsData: (config) => instance.get('/api/EvCharging/Distributors', Object.assign({}, config)), // 取得分電盤資料
    getDistributorAlertLog: (params) => instance.get('/api/EvCharging/Distributor/AlertLog', { params }) // 取得分電盤資料
  }
}
